@if(fraccionamientoIntegraciones$ | async; as fraccionamientoIntegraccion) {
    @if(fraccionamientoIntegraccion.data.length > 0) {
        <div>
            <div class="w-full flex flex-col md:flex-row md:justify-end">
                <button
                    mat-raised-button 
                    *hasPermissions="'agregar_desmembracion_fraccionamiento' ; modulos ['DetalleBienCultural']"
                    (click)="integracionesFraccionamiento(ficha, true)"
                    class="w-full md:w-auto rounded-sm m-0.5 md:mr-0.5">
                    Agregar Nueva Desmembración
                </button>

                <button
                    mat-raised-button 
                    *hasPermissions="'agregar_elementos_conformantes' ; modulos ['DetalleBienCultural']"
                    (click)="integracionesFraccionamiento(ficha, false)"
                    class="w-full md:w-auto rounded-sm m-0.5 md:mr-0.5">
                    Agregar elemento conformante
                </button>
            </div>

            <div class="w-full overflow-x-auto mt-2">
                <table mat-table [dataSource]="fraccionamientoIntegraccion.data" class="w-full table-auto">
                    <!-- NoRegistro Column -->
                    <ng-container matColumnDef="NoRegistro">
                        <td mat-cell *matCellDef="let item" >
                            <div class="flex items-center gap-2 whitespace-nowrap md:whitespace-normal">
                                <mat-icon>foundation</mat-icon>
                            <span>{{item.noRegistro}}</span>
                            </div>    
                        </td>
                    </ng-container>

                    <!-- nombre Por Column -->
                    <ng-container matColumnDef="nombre">
                        <td mat-cell *matCellDef="let item">
                            <div  class="flex items-center gap-2 whitespace-nowrap md:whitespace-normal">
                                {{item.nombreBienCultural}}
                            </div>
                        </td>
                    </ng-container>

                    <!-- tipoOperacion Por Column -->
                    <ng-container matColumnDef="tipoOperacion">
                        <td mat-cell *matCellDef="let item">
                            <div  class="flex items-center gap-2 whitespace-nowrap md:whitespace-normal">
                                <span  class="px-2 rounded-full text-sm font-bold text-white"
                                    [ngStyle]="{
                                        'background-color': item.tipoOperacion?.valor1, 
                                    }">
                                        {{item.tipoOperacion?.descripcion}}
                                </span>
                            </div>
                        </td>
                    </ng-container>

                    <!-- link Column -->
                    <ng-container matColumnDef="link">
                        <td mat-cell *matCellDef="let item" >
                            <button (click)="DetalleBienCultural(item.bienCulturalUuid)" class="whitespace-nowrap pr-6 text-sm ">
                                <mat-icon [svgIcon]="'heroicons_solid:arrow-top-right-on-square'" ></mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    
                    <tr mat-row *matRowDef="let row; columns: ['NoRegistro', 'nombre', 'tipoOperacion', 'link']" class="border-b"></tr>
                </table>
            </div>

        </div>
    }@else{
        <div class="w-full flex justify-center items-center h-64">
            <span class="text-center text-gray-500">No hay fraccionamientos o elementos conformantes plásticas registradas.</span>
        </div>
    }   
}